import React, { useEffect, useState, useCallback, useRef, useContext, useMemo } from 'react'
import { px2rem, rem2px } from '@/utils/styleUtils'
import Head from 'next/head'
import styles from './index.module.less'
import { isCanHiddenNav } from '@/utils/appUtils/getDevice'
import jockey from '@/utils/jockey'
import { ComponentItemType, GlobalConfigType } from '@/typings/types'

function CustomNav(props: { globalConfig: GlobalConfigType; componentList: ComponentItemType[] }) {
  const domRef = useRef(null)
  const { globalConfig, componentList } = props
  const { navigationBackground, colorMode, title, buttonColor } = globalConfig
  const [navBgColor, setNavBgColor] = useState('transparent')
  const [statusBarHeight, setBarHeight] = useState(px2rem(52))
  const [visibility, setVisibility] = useState<'hidden' | 'visible'>('hidden')
  const buttonStyle = {
    backgroundColor: buttonColor,
  }
  const shareItem = componentList.find((it) => it.name === 'poizon-share')

  const pageTitleItem = componentList.find((it) => it.name === 'poizon-page-title')

  const handlerRef = useRef({ listenHandler: () => {} })

  handlerRef.current.listenHandler = function handleScroll() {
    const scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      window.pageYOffset ||
      document.body.scrollTop ||
      0
    const offsetheight = domRef.current.offsetHeight
    if (scrollTop > offsetheight) {
      setNavBgColor(navigationBackground)
    } else {
      if (colorMode === 0) {
        setNavBgColor(navigationBackground)
        return
      }
      setNavBgColor('transparent')
    }
  }

  const handleGoback = useCallback(() => {
    jockey.closeCurrentPage()
  }, [])

  const {
    title: shareTitle = '賣家大召集！POIZON年尾重磅福利來襲！',
    description = '全場費率勁減最低至3%！快嚟賣野啦>>>',
    link,
    imgUrl = 'https://cdn.poizon.com/node-common/d12eb0087f5ec9ccb00b4ee6d6c97a9d.jpg',
  } = (shareItem && shareItem.propsConfig) || {}

  const handleShare = useCallback(() => {
    jockey.socialShare({
      title: shareTitle,
      description,
      link: link || (typeof window !== 'undefined' ? location.href : ''),
      imgUrl,
    })
  }, [shareItem && shareItem.propsConfig])

  // 需要第一时间执行，不然webview初始顶不上去
  useEffect(() => {
    // // 设置状态栏透明
    // jockey.setStatusBarTransparent(1)
    // 获取状态栏高度
    jockey.getPlatformInfoCallback((d) => {
      setBarHeight(px2rem(d.statusBarHeight + 17))
    })
    jockey.getPlatformInfo()
  }, [])

  useEffect(() => {
    if (globalConfig.hideNavigation === 1 && isCanHiddenNav()) {
      console.error('domRef.current.style.visibility visible')
      // domRef.current.style.visibility = 'visible'
      setVisibility('visible')
    } else {
      // domRef.current.style.visibility = 'hidden'
      setVisibility('hidden')
    }
  }, [domRef.current])

  useEffect(() => {
    // 修正设为透明时不生效，要滚动之后才生效的问题
    if (colorMode === 1) {
      // 配置为透明色
      setNavBgColor('transparent')
    } else {
      setNavBgColor(navigationBackground)
    }
  }, [colorMode])

  useEffect(() => {
    if (typeof window === 'undefined' || !isCanHiddenNav()) {
      return
    }
    if (props.globalConfig.hideNavigation && isCanHiddenNav()) {
      console.error('hidden topbar....')
      jockey.setStatusBarTransparent(1)
    }
    window.addEventListener('scroll', handlerRef.current.listenHandler)
    return () => {
      window.removeEventListener('scroll', handlerRef.current.listenHandler)
    }
  }, [])

  const usedTitle = useMemo(() => {
    if (pageTitleItem?.propsConfig?.pageTitle) {
      return pageTitleItem?.propsConfig?.pageTitle
    }
    return title
  }, [pageTitleItem, title])
  return (
    <div
      // key={navBgColor}
      className={styles.navigationWrap}
      style={{
        backgroundColor: navBgColor,
        paddingTop: statusBarHeight,
        // opacity: navBgColor === 'transparent' ? 0 : 1,
        visibility,
      }}
      ref={domRef}
    >
      <div className={styles.navigation}>
        <span className={styles.goBack} style={buttonStyle} onClick={handleGoback}></span>
        <span className={styles.pageTitle} style={{ color: buttonColor }}>
          {usedTitle}
        </span>
        {shareItem ? (
          // 方便业务直接在页面注入事件，来做分享埋点
          <span
            id="share"
            className={styles.share}
            style={buttonStyle}
            onClick={handleShare}
          ></span>
        ) : (
          <span className={styles.placeholder}></span>
        )}
      </div>
      {shareItem && shareItem.propsConfig && (
        <Head>
          <meta property="og:type" content="website" key="type" />
          <meta property="og:title" content={shareTitle} key="title" />
          <meta property="og:description" content={description} key="description" />
          <meta property="og:image" content={imgUrl} key="image" />
          <meta property="description" content={description} key="doc-description" />
        </Head>
      )}
    </div>
  )
}

export default CustomNav
